<template>
  <slot name="appSidebar" />
  <slot name="appMainContent" />
</template>

<script lang="ts" setup></script>
